export default __webpack_public_path__ + "static/media/filter_icon_vac.3da39acb.svg";